<template>
    <div class="form-group search-container" v-bind:class="extendedClass">
        <div v-show="showMenu">
            <div
                class="search-icon-container search-menu-icon"
                @click="$_onMenu"
                :title="internalTooltipMenu"
            >
                <span :class="iconMenu"></span>
            </div>
            <div class="search-icon-container search-separator-icon"></div>
        </div>
        <base-input
            :id="name"
            :name="name"
            ref="searchInput"
            type="text"
            v-model="computedValue"
            :extendedClass="getExtendedClass"
            :placeholder="info"
            @input="onInput"
            @keydown="$_onKeydown"
            @keyup="$_onKeyup"
            @focus="$_onFocus"
            @blur="$emit('blur')"
            :autofocus="autofocus"
            autocomplete="off"
        >
        </base-input>
        <div class="search-icon-container search-icon" v-show="!hasSearchValue && showSearchIcon">
            <em aria-hidden="true"></em>
        </div>
        <div
            class="search-icon-container search-clear-icon"
            v-show="hasSearchValue"
            @click="clearSearch"
            :title="$t('labelClear')"
        >
            <em aria-hidden="true"></em>
        </div>
        <div
            class="search-icon-container save-icon-container save-search-icon"
            v-show="hasSearchValue && showSaveButton"
            @click="$emit('save', $event)"
            :title="$t('userSearches.save')"
        >
            <em aria-hidden="true"></em>
        </div>
    </div>
</template>

<script>
    import BaseInput from './BaseComponents/base-input.vue';
    export default {
        name: 'SearchBox',

        components: { 'base-input': BaseInput },

        props: {
            id: { type: String, required: false, default: 'bv-search-id' },
            name: { type: String, required: false, default: 'bv-searchField' },
            value: { type: [String, Number], required: false },
            info: String,
            autofocus: { type: Boolean, required: false },
            extendedClass: { type: [String, Object], default: 'col-md-3' },
            showMenu: { type: Boolean, required: false, default: false },
            iconMenu: { type: String, required: false, default: 'navigation-icon' },
            tooltipMenu: {
                type: String,
                required: false,
                default: ''
            },
            showSearchIcon: { type: Boolean, required: false, default: true },
            showSaveButton: { type: Boolean, required: false, default: false },
            saveInState: { type: Boolean, required: false, default: false }
        },

        data: function () {
            return { searchText: '', internalTooltipMenu: null };
        },

        created() {
            // Set the default value using $t()
            this.internaltooltipMenu = this.tooltipMenu || this.$t('labelMenu');
        },

        computed: {
            hasSearchValue() {
                return this.searchText && this.searchText.length > 0;
            },

            computedValue: {
                get() {
                    return this.searchText || this.value;
                },

                set(input) {
                    this.searchText = input;
                }
            },

            getExtendedClass() {
                return this.showMenu
                    ? 'search-bar search-bar-padding-left'
                    : 'search-bar';
            }
        },

        mounted() {
            if (this.saveInState) {
                const filter = this.$store.getters.getFilterFromState(this.id);
                if (filter !== undefined) {
                    this.$emit('input', filter.value);
                    this.searchText = filter.value;
                }
            }
        },

        methods: {
            clearSearch() {
                this.searchText = '';
                this.$emit('input', this.searchText);
            },

            onInput(input) {
                this.$emit('input', input);
                this.$_saveInputInState(input);
            },

            $_onFocus(input) {
                this.$emit('focus', input);
            },

            $_onKeyup(evt) {
                this.$emit('keyup', evt);
            },

            $_onKeydown(evt) {
                this.$emit('keydown', evt);
            },

            $_onMenu(evt) {
                this.$emit('click', evt);
            },

            $_saveInputInState(input) {
                if (this.saveInState) {
                    this.$store.commit('SET_UI_FILTERS', {
                        id: this.id,
                        value: input
                    });
                }
            }
        },

        watch: {
            value(newValue, oldValue) {
                if (
                    newValue !== null &&
                    newValue !== undefined &&
                    newValue !== oldValue
                ) {
                    this.searchText = newValue;
                }
                this.onInput(this.searchText);
            }
        }
    };
</script>

<style>
.search-bar {
    padding-right: 35px;
}

.search-bar-padding-left {
    padding-left: 42px;
}
</style>

<style scoped lang="scss">
.search-container {
    padding-right: 0px;
    margin-right: 15px;
}

.search-icon-container {
    position: absolute;
    right: 8px;
    width: 20px;
    height: 20px;
    z-index: 4;

    & em {
        padding-right: 20px;
    }

    &.save-icon-container {
        right: 30px;
    }
}

.search-menu-icon {
    left: 3px;
    top: 3px;
    width: 30px;
    height: 30px;
    padding: 5px 0px 0px 5px;
    cursor: pointer;
}

.search-menu-icon span {
    position: absolute;
    width: 20px;
    height: 20px;
    background-size: 20px;
}

.search-separator-icon {
    border-left: 1px solid #b7b7b7;
    left: 35px;
    top: 6px;
    height: 24px;
}

.search-icon {
    top: 7px;
}

.search-icon em {
    background-image: url(~@/assets/imported-icons/ic_fluent_search_20_regular.svg);
    background-repeat: no-repeat;
    background-size: 22px;
}

.search-clear-icon {
    top: 7px;
    cursor: pointer;
}

.search-clear-icon em {
    background-image: url(~@/assets/imported-icons/ic_fluent_dismiss_20_regular.svg);
    background-repeat: no-repeat;
    background-size: 22px;
}

.save-search-icon {
    top: 7px;
    cursor: pointer;
}

.save-search-icon em {
    background-image: url(~@/assets/imported-icons/ic_fluent_save_20_regular.svg);
    background-repeat: no-repeat;
    background-size: 22px;
}
</style>
